/**
 * Sélecteur d'année partagé par les grilles (Revenus, Mesures, Salaires,
 * Loyers, Charges, RH).
 *
 * Les années proposées sont l'année lue et ses voisines, plus l'année pivot
 * (2026, première année budgétée dans l'outil) pour pouvoir toujours revenir
 * au budget de référence. La liste est dédoublonnée : l'ancienne version
 * concaténait le pivot sans vérifier sa présence, ce qui produisait deux
 * options « 2026 » de même clé React dès que l'on affichait 2027 — et donc
 * une liste déroulante incohérente.
 */
export const ANNEE_PIVOT = 2026;

export function SelectAnnee({ annee, onChange }: { annee: number; onChange: (a: number) => void }) {
  const annees = Array.from(new Set([ANNEE_PIVOT, annee - 1, annee, annee + 1]))
    .filter((a) => a >= ANNEE_PIVOT) // rien n'est saisi avant 2026 : une grille antérieure serait vide
    .sort((a, b) => a - b);

  return (
    <select
      className="sort-select"
      value={annee}
      onChange={(e) => onChange(Number(e.target.value))}
      title="Année"
    >
      {annees.map((a) => <option key={a} value={a}>{a}</option>)}
    </select>
  );
}
